var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipBottomRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 431,
    viewBox: "0 0 352 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M257.457 141.178L71.4375 388.141H295.266L481.289 141.178H257.457Z",
    fill: "url(#paint0_linear_15641_48917)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M376.57 551.687L504.545 381.785H350.558L222.586 551.687H376.57Z",
    fill: "url(#paint1_linear_15641_48917)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.145 372.227H220.424L59.5595 585.796H45.2812L206.145 372.227Z",
    fill: "url(#paint2_linear_15641_48917)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M430.939 147.537H564.603L223.437 600.472H89.7734L430.939 147.537Z",
    fill: "url(#paint3_linear_15641_48917)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M605.33 0.21875H738.996L397.83 453.157H264.164L605.33 0.21875Z",
    fill: "url(#paint4_linear_15641_48917)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M147.793 420.751H205.327L58.4757 615.714H0.941406L147.793 420.751Z",
    fill: "url(#paint5_linear_15641_48917)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M366.631 362.348H436.902L257.54 600.474H187.266L366.631 362.348Z",
    fill: "url(#paint6_linear_15641_48917)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M311.697 352.053H241.426L420.791 113.925H491.062L311.697 352.053Z",
    fill: "url(#paint7_linear_15641_48917)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.586 78.9985C360.419 75.2223 364.864 73 369.585 73H473.995C486.357 73 493.412 87.1132 485.994 97.0015L169.414 519.001C166.581 522.778 162.136 525 157.415 525H63.0061C46.5241 525 37.1167 506.182 47.0076 492.998L357.586 78.9985Z",
    fill: "url(#paint8_linear_15641_48917)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15641_48917",
    x1: 298.796,
    y1: 312.272,
    x2: 191.195,
    y2: 84.0577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F7FCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#DAF9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C6F5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAF3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F3C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15641_48917",
    x1: 348.132,
    y1: 433.981,
    x2: 422.156,
    y2: 590.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F7FCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#DAF9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C6F5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAF3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F3C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15641_48917",
    x1: 132.851,
    y1: 375.935,
    x2: 132.851,
    y2: 629.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDF3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#91EC8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58E35E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15641_48917",
    x1: 327.188,
    y1: 134.186,
    x2: 327.188,
    y2: 451.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8F3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#91EC8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58E366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15641_48917",
    x1: 501.579,
    y1: 180.81,
    x2: 501.579,
    y2: 508.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#91EC8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE358"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15641_48917",
    x1: 103.133,
    y1: 423.35,
    x2: 103.133,
    y2: 538.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8FEC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58E36E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15641_48917",
    x1: 312.084,
    y1: 368.889,
    x2: 312.084,
    y2: 570.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DCF9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBF3B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15641_48917",
    x1: 366.244,
    y1: 345.51,
    x2: 366.244,
    y2: 144.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DCF9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7F3B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15641_48917",
    x1: 300.548,
    y1: 311.721,
    x2: -192.826,
    y2: -9.72531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49CE66",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D562"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipBottomRight);
export default __webpack_public_path__ + "static/media/clip-bottom-right.434657e9ee3691f17eba2c63f06ecca7.svg";
export { ForwardRef as ReactComponent };